<template lang="pug">
  .page(v-if="board")
    .widget-tabs
      .tabs
        .tab.primary-text(@click="selectTab('widget')", :class="{active: selectedTab === 'widget'}")
          span Widget

        .tab.primary-text(@click="selectTab('code')", :class="{active: selectedTab === 'code'}")
          span Code

    .widget-tab-widget(v-if="selectedTab === 'widget'")
      .info-section
        h3 Gather user feedback right on your site
        p By embedding our widget right on your website you offer a seamless experience for your users to gather their feedback and issues.
      .sub-section
        h4 Add any domains you want to be able to render this board's widget on.
        form(@submit.prevent="submit")

          div.form-field(:class="{error: $v.form.domain.$error, 'error-required': !$v.form.domain.required}")
            label
              h6 Add Domain
              input(v-model="$v.form.domain.$model", type="text", placeholder="myapp.com")
              //-.error(v-if="$v.form.domain.$error && !$v.form.domain.url") Value is not a domain

          div.form-field.no-margin
            SubmitButton(label="Add", :formState="formState")
      .domains(v-if="board.widgetDomains.length > 0")
        table
          tr
            th Allowed Domains
            th
          tr(v-for="domain in board.widgetDomains")
            td {{ domain }}
            td
              span(@click="removeDomain(domain)")
                font-awesome-icon.icon(:icon="['fas', 'times']")

    .widget-tab-widget(v-if="selectedTab === 'code'")
      .info-section
        p Copy this code onto your website where you'd like this board to appear.

      
      .sub-section
        .row.center.apart
          .col
            h3 Example Code
          .col
            .code-select
              SelectInput(:options="codeTypes", v-model="codeType")
        
        pre {{ widgetCode }}

    //-div
      form(@keyup.enter="submit", @submit.prevent="submit")
        div.form-field
          button.button(type="submit") submit

</template>

<script>

import { required, url } from 'vuelidate/lib/validators'
import { mapState, mapGetters } from 'vuex'
import { form } from '@/mixins/form'
import SelectInput from '@/components/helpers/SelectInput'


const codeTypes = [{
  name: 'HTML',
  _id: 'html'
}, {
  name: 'Vue',
  _id: 'vue'
}]

export default {
  name: 'BoardSettingsWidget',
  mixins: [form],
  components: {
    SelectInput
  },
  data () {
    return {
      selectedTab: 'widget',
      formState: 'initial',
      form: {
        domain: ''
      },
      codeTypes,
      codeType: codeTypes[0]._id
    }
  },
  validations: {
    form: {
      domain: {
        required,
        //url
      }
    }
  },
  beforeCreate () {
    this.$store.dispatch('getCompany')
      .then(() => {
      })

  },
  computed: {
    ...mapState({
      company: state => state.company,
    }),
    ...mapGetters({
      board: 'boards/selected',
    }),
    widgetCode () {
      //let company = this.company.name
      let code = ''
      if (!this.company || !this.board) return code

      if (this.codeType === 'html') {
        code =  `<feature-watch options="options">
  <button type="button">Open Feature.Watch</button>
</feature-watch>

<script src="https://assets-cdn.feature.watch/widget/feature-watch.min.js"><\/script>
<script>
    var options = {
        company: '${this.company.subdomain}',
        board: '${this.board.slug}',
        user: {
            firstName: 'Johnny',
            lastName: 'Danger',
            email:'johnnydanger@gmail.com'
        }
    };
    document.querySelector('feature-watch').options = options;
<\/script>`
      } else if (this.codeType === 'vue') {
        code = `<template>
  <feature-watch :options="fwOptions", v-pre>Feedback</feature-watch>
</template>

<script>

export default {
  mounted() {
    let fwScript = document.createElement('script')
    fwScript.setAttribute('src', 'https://assets-cdn.feature.watch/widget/feature-watch.min.js')
    document.head.appendChild(fwScript)

    let options = {
      company: '${this.company.subdomain}',
      board: '${this.board.slug}',
      user: {
        firstName: 'Johnny',
        lastName: 'Danger',
        email:'johnnydanger@gmail.com'
      }
    }

    fwScript.onload = function() {
      document.querySelector('feature-watch').options = options;
    }
  }
}
<\/script>`
      }
      return code
    }
  },
  methods: {
    selectTab (tab) {
      this.selectedTab = tab
    },
    submit () {

      if (this.__formInvalid()) return

      let widgetDomains = this.board.widgetDomains || []

      let updates = {
        widgetDomains: [...widgetDomains, this.form.domain]
      }

      //console.log(updates)

      this.$store.dispatch('boards/updateBoard', updates).then(() => {
        //this.pending = [...this.pending, invite]
        this.formState = 'success'
        this.form = {
          domain: ''
        }
        this.$v.$reset()
      }, errors => {
        this.formState = 'error'
        this.errors = errors
        console.log(errors)
      })
    },
    removeDomain (domain) {
      let domains = [...this.board.widgetDomains]
      domains.splice(domains.indexOf(domain), 1)
      let updates = {
        widgetDomains: domains
      }
      console.log(updates)

      this.$store.dispatch('boards/updateBoard', updates).then(() => {
        //this.pending = [...this.pending, invite]
      }, errors => {
        this.formState = 'error'
        this.errors = errors
        console.log(errors)
      })
    }
  }
}
</script>

<style scoped lang="stylus">
  pre
    //background-color $background-color
    //border $border-default
    //border-radius $border-radius
    font-family courier
    font-size 12px
    padding $spacing-2 0

  .widget-tabs
    .tabs
      margin-bottom $spacing-4
      
  .code-select
    background-color #fff
    min-width 100px

  .domains
    .icon
      height 16px
</style>
